__turbopack_context__.v({
  "root": "SharpnessBackground-module-scss-module__tDnJEW__root",
});
